// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Hl1t","wrapper":"wrapper__1GvZd","section":"section__-WZEH","sliceWrap":"sliceWrap__1k-t_","slice":"slice__24mKQ","key":"key__jD7VM","keyInner":"keyInner__1zU5a","text":"text__ChQj9","textDescriptionInner":"textDescriptionInner__QHGRR","textInner":"textInner__30-7y","hidden":"hidden__3DfOZ"};


//////////////////
// WEBPACK FOOTER
// ./components/RadialChart/style.css
// module id = +db1
// module chunks = 0